import { render, staticRenderFns } from "./table-head.vue?vue&type=template&id=bfc1b106&scoped=true"
import script from "./table-head.vue?vue&type=script&lang=ts"
export * from "./table-head.vue?vue&type=script&lang=ts"
import style0 from "./table-head.vue?vue&type=style&index=0&id=bfc1b106&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc1b106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc1b106')) {
      api.createRecord('bfc1b106', component.options)
    } else {
      api.reload('bfc1b106', component.options)
    }
    module.hot.accept("./table-head.vue?vue&type=template&id=bfc1b106&scoped=true", function () {
      api.rerender('bfc1b106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/table/table-head.vue"
export default component.exports